<template>
  <div
    id="pulseMain"
    :class="['mobile', 'tablet'].includes($mq) ? 'mobileMode' : 'deskMode'"
  >
    <!-- Logo area -->
    <el-row
      type="flex"
      class="logoWrap"
      :class="`${$mq}Mode`"
    >
      <el-col
        class="logoCol"
        :span="responsiveCol"
      >
        <div
          class="logo"
          @click="$router.push({name: 'login'}).catch((err) => {})"
        >
          <img
            src="@/assets/logo/gcg_logo.png"
            alt="logo"
          />
        </div>
      </el-col>

      <el-col
        v-if="$mq !== 'mobile'"
        class="sloganCol"
        :span="responsiveCol"
      >
        <div class="slogan">
          <img
            src="@/assets/logo/gcg_slogan.png"
            alt="logo"
          />
        </div>
      </el-col>
    </el-row>

    <!-- Cover, Survey page -->
    <cvcSurvey
      v-if="accessData && !error && !confirmation"
      :loading-wrap="loadingWrap"
      :pulse-data="accessData"
      :error.sync="error"
      :error-data.sync="errorData"
      :confirmation.sync="confirmation"
      :confirmed-data.sync="confirmedData"
      :dialog-width="dialogWidth"
      :dialog-padding="dialogPadding"
    />

    <!-- Error page -->
    <cvcError
      v-else-if="error"
      :error-data="errorData"
      :dialog-width="dialogWidth"
    />

    <!-- Confirmed page -->
    <cvcConfirmation
      v-else-if="confirmation"
      :pulse-data="accessData"
      :confirmed-data.sync="confirmedData"
      :dialog-width="dialogWidth"
      :dialog-padding="dialogPadding"
    />

    <Footer />
  </div>
</template>

<script>
import api from '@/api';
import DialogSetting from '@/mixins/dialog';
import Footer from '@/views/dashboard/layout/Footer.vue';
import cvcSurvey from './CvcSurvey.vue';
import cvcError from './CvcError.vue';
import cvcConfirmation from './CvcConfirmation.vue';

export default {
  components: {
    cvcSurvey,
    cvcError,
    cvcConfirmation,
    Footer,
  },

  mixins: [DialogSetting],

  data() {
    return {
      loadingWrap: false,
      error: false,
      errorData: {
        code: 0,
        text: this.$t('cvc.alreadySubmitted'),
        key: '',
      },
      confirmation: false,
      accessData: {},
      confirmedData: {
        coach: {
          first_name: '',
          last_name: '',
          email: '',
        },
      },
    };
  },

  computed: {
    responsiveCol() {
      let col = 12;
      if (this.$mq === 'mobile') {
        col = 24;
      }
      return col;
    },
  },

  created() {
    this.fetchLeaderData();
  },

  methods: {
    async fetchLeaderData() {
      try {
        this.loadingWrap = true;
        let response = null;

        response = await api.getEngagementCvcSurvey(this.$route.params.id);

        this.accessData = response.data;
      } catch (err) {
        if (err.msg && err.key !== 'cvcAlreadySubmitted') {
          this.errorData.text = err.msg;
        }

        if (err.code === 406) {
          this.errorData.code = 406;
        }

        if (err.key) {
          this.errorData.key = err.key;
        }

        this.error = true;
      } finally {
        this.loadingWrap = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#pulseMain {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
  background: #1145a4;
  justify-content: space-between;

  .logoWrap {
    width: 100%;
    padding: 45px 5% 10px;
    display: block !important;

    .logoCol {
      .logo {
        img {
          width: 110px;
        }
      }
    }

    .sloganCol {
      text-align: right;

      .slogan {
        img {
          width: 180px;
        }
      }
    }

    &.mobileMode {
      padding: 30px 0;

      .logoCol {
        text-align: center;

        .logo {
          img {
            width: 100px !important;
          }
        }
      }
    }

    &.tabletMode {
      padding: 40px 5%;

      .logoCol {
        .logo {
          img {
            width: 100px !important;
          }
        }
      }

      .sloganCol {
        .slogan {
          img {
            width: 170px !important;
          }
        }
      }
    }
  }

  &.mobileMode {
    height: unset;
    min-height: 100vh;
  }
}
</style>
